import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Language } from '../models/language.model';

@Injectable()
export class LanguageService {
  languageChanged$: Observable<string> = new Observable();

  private languageChangedSubject: Subject<string> = new Subject();
  private readonly apiController = 'api/language';

  constructor(private readonly httpService: HttpClient) {
    this.languageChanged$ = this.languageChangedSubject.asObservable();
  }

  getDefaultLanguage() {
    return this.httpService.get(
      `${this.apiController}/defaultlanguage`
    ) as Observable<Language>;
  }

  emitChangeLanguage(languageName: string) {
    this.languageChangedSubject.next(languageName);
  }
}
